import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { useEcoSaltEligibility } from "hooks/useEcoSaltUpgrade";
import { getRoleHomePath } from "utils/paths";
import { LoadingScreen } from "./shared/LoadingScreen";

/** Only signed-in users with the "ecosalt-upgrade" feature flag (checked by the API) get through. */
const EcoSaltUpgradeRoute: React.FC = () => {
  const { user } = useAuth();
  const { enabled, isLoading } = useEcoSaltEligibility();
  if (isLoading) return <LoadingScreen fullPage message="Checking permissions..." />;
  if (!enabled) return <Navigate to={getRoleHomePath(user?.role)} replace />;
  return <Outlet />;
};

export default EcoSaltUpgradeRoute;
